import { Directive, ElementRef, HostListener, Input, ChangeDetectorRef, EventEmitter, Output, OnInit } from "@angular/core";
import { NgModel, } from "@angular/forms";
import { DecimalPipe } from "@angular/common";
import { Subscription } from "rxjs";

@Directive({
	selector: "[inputPercent]",
	providers: [ DecimalPipe ],
	standalone: false,
})
export class PercentInputDirective implements OnInit {
	@Input() decimals = 0;
	@Input() digit = 1;
	@Output() sharedVarChange = new EventEmitter();
	@Input() greaterThan100: boolean;
	ss: Subscription;

	private specialKeys = [
		"Backspace",
		"Tab",
		"End",
		"Home",
		"ArrowLeft",
		"ArrowRight",
		"Delete"
	];

	constructor(
		private el: ElementRef,
		private decimalPipe: DecimalPipe,
		private cdr: ChangeDetectorRef,
		private model: NgModel
	) {
	}

	ngOnInit() {
		this.model.valueChanges.subscribe(value => {
			if (this.model.control.pristine && value) {
				const toPercent: any = value;
				const percentStr: string = `${toPercent}%`;
				this.model.valueAccessor.writeValue(percentStr);
			}
		});
	}

	@HostListener("keydown", ["$event"])
	onKeyDown(event: KeyboardEvent) {
		const selectShortcut = event.ctrlKey && event.key == "a";
		const copyShortcut = event.ctrlKey && event.key == "c";
		const pasteShortcut = event.ctrlKey && event.key == "v";
		const undoShortcut = event.ctrlKey && event.key == "z";

		const ifAnyShortcut = selectShortcut || copyShortcut || pasteShortcut || undoShortcut;
		if (ifAnyShortcut || this.specialKeys.indexOf(event.key) !== -1) {
			return '';
		}

		const current: string = this.el.nativeElement.value;
		const position: number = this.el.nativeElement.selectionStart;
		const next: string = [
			current.slice(0, position),
			event.key,
			current.slice(position)
		].join("");
		if (next && !this.check(next, this.decimals, this.digit)) {
			event.preventDefault();
			return next;
		}
		return '';
	}

	@HostListener("blur")
	onBlur() {
		const decimalZeroes = "0".repeat(this.decimals);
		let uiValue = `0.${decimalZeroes}`;
		const onBlurValue: string = this.el.nativeElement.value;
		const parsedValue: number = parseFloat(onBlurValue);

		if (!this.greaterThan100 && parsedValue > 100.0) {
			uiValue = `100.${decimalZeroes}`;
		} else if (!isNaN(parsedValue)) {
			uiValue = this.decimalPipe.transform(parsedValue, "1." + this.decimals + "-" + this.decimals);
		}
		this.el.nativeElement.value = uiValue + "%";
		this.model.control.markAsPristine();
	}

	@HostListener("focus")
	onFocus() {
		const next1: string = this.el.nativeElement.value;
		if (next1.indexOf("%") != -1) {
			this.el.nativeElement.value = next1.substring(0, next1.length - 1);
		}
	}

	private check(value: string, decimals: number, digit: number) {
		if (decimals <= 0) {
			return String(value).match(new RegExp(/^\d+$/));
		} else {
			const regExpString = `^\\-?(\\d{0,${digit}}(\\.\\d{0,${decimals}})?)$`;
			return String(value).match(new RegExp(regExpString, "gm"));
		}
	}
}
